import React from "react";
import { Box, Typography } from "@mui/material";

import { colors } from "../../utils/colors";

function RoundList({
  setSelectedItem,
  selectedItem,
  index,
  roundItem,
  number,
}) {
  const boxStyling = {
    backgroundColor: roundItem.rounds === number ? colors.PRIMARY : "none",
    border:
      roundItem.rounds === number
        ? "1px solid transparent"
        : "1px solid #2C633C",
    textAlign: "center",
    padding: "8px 0px",
    borderRadius: "8px",
    cursor: "pointer",
  };

  return (
    <Box
      // onClick={() => setSelectedItem(index)}
      sx={boxStyling}
    >
      <Typography
        variant="body1"
        fontWeight="bold"
        sx={{ color: roundItem.rounds === number ? "#fff" : "#2C633C" }}
      >
        {roundItem.label}
      </Typography>
    </Box>
  );
}

export default RoundList;
